import SportIndex from './SportIndex';
import SportCreate from './SportCreate';
import SportSettings from './SportSettings';
import SportSingle from './SportSingle';

export default function (app) {

    const settings = SportSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    SportIndex(app, settings);

    SportCreate(app, settings);

    SportSingle(app, settings);

}